const KeyEventValues = {
  BACKSPACE: { which: 8, key: 'Backspace', code: 'Backspace' },
  TAB: { which: 9, key: 'Tab', code: 'Tab' },
  ENTER: { which: 13, key: 'Enter', code: 'Enter' },
  SHIFT_LEFT: { which: 16, key: 'Shift', code: 'ShiftLeft' },
  SHIFT_RIGHT: { which: 16, key: 'Shift', code: 'ShiftRight' },
  CNTRL_LEFT: { which: 17, key: 'Control', code: 'ControlLeft' },
  CNTRL_RIGHT: { which: 17, key: 'Control', code: 'ControlRight' },
  ALT_LEFT: { which: 18, key: 'Alt', code: 'AltLeft' },
  ALT_RIGHT: { which: 18, key: 'Alt', code: 'AltRight' },
  PAUSE: { which: 19, key: 'Pause', code: 'Pause' },
  CAPS_LOCK: { which: 20, key: 'CapsLock', code: 'CapsLock' },
  ESCAPE: { which: 27, key: 'Escape', code: 'Escape' },
  SPACE: { which: 32, key: '', code: 'Space' },
  PAGE_UP: { which: 33, key: 'PageUp', code: 'PageUp' },
  PAGE_DOWN: { which: 34, key: 'PageDown', code: 'PageDown' },
  END: { which: 35, key: 'End', code: 'End' },
  HOME: { which: 36, key: 'Home', code: 'Home' },
  ARROW_LEFT: { which: 37, key: 'ArrowLeft', code: 'ArrowLeft' },
  ARROW_UP: { which: 38, key: 'ArrowUp', code: 'ArrowUp' },
  ARROW_RIGHT: { which: 39, key: 'ArrowRight', code: 'ArrowRight' },
  ARROW_DOWN: { which: 40, key: 'ArrowDown', code: 'ArrowDown' },
  PRINT_SCREEN: { which: 44, key: 'PrintScreen', code: 'PrintScreen' },
  INSERT: { which: 45, key: 'Insert', code: 'Insert' },
  DELETE: { which: 46, key: 'Delete', code: 'Delete' },
  NUM_0: { which: 48, key: '0', code: 'Digit0' },
  NUM_1: { which: 49, key: '1', code: 'Digit1' },
  NUM_2: { which: 50, key: '2', code: 'Digit2' },
  NUM_3: { which: 51, key: '3', code: 'Digit3' },
  NUM_4: { which: 52, key: '4', code: 'Digit4' },
  NUM_5: { which: 53, key: '5', code: 'Digit5' },
  NUM_6: { which: 54, key: '6', code: 'Digit6' },
  NUM_7: { which: 55, key: '7', code: 'Digit7' },
  NUM_8: { which: 56, key: '8', code: 'Digit8' },
  NUM_9: { which: 57, key: '9', code: 'Digit9' },
  A: { which: 65, key: 'a', code: 'KeyA' },
  B: { which: 66, key: 'b', code: 'KeyB' },
  C: { which: 67, key: 'c', code: 'KeyC' },
  D: { which: 68, key: 'd', code: 'KeyD' },
  E: { which: 69, key: 'e', code: 'KeyE' },
  F: { which: 70, key: 'f', code: 'KeyF' },
  G: { which: 71, key: 'g', code: 'KeyG' },
  H: { which: 72, key: 'h', code: 'KeyH' },
  I: { which: 73, key: 'i', code: 'KeyI' },
  J: { which: 74, key: 'j', code: 'KeyJ' },
  K: { which: 75, key: 'k', code: 'KeyK' },
  L: { which: 76, key: 'l', code: 'KeyL' },
  M: { which: 77, key: 'm', code: 'KeyM' },
  N: { which: 78, key: 'n', code: 'KeyN' },
  O: { which: 79, key: 'o', code: 'KeyO' },
  P: { which: 80, key: 'p', code: 'KeyP' },
  Q: { which: 81, key: 'q', code: 'KeyQ' },
  R: { which: 82, key: 'r', code: 'KeyR' },
  S: { which: 83, key: 's', code: 'KeyS' },
  T: { which: 84, key: 't', code: 'KeyT' },
  U: { which: 85, key: 'u', code: 'KeyU' },
  V: { which: 86, key: 'v', code: 'KeyV' },
  W: { which: 87, key: 'w', code: 'KeyW' },
  X: { which: 88, key: 'x', code: 'KeyX' },
  Y: { which: 89, key: 'y', code: 'KeyY' },
  Z: { which: 90, key: 'z', code: 'KeyZ' },
  LEFT_WINDOW_KEY: { which: 91, key: 'Meta', code: 'MetaLeft' },
  RIGHT_WINDOW_KEY: { which: 92, key: 'Meta', code: 'MetaRight' },
  SELECT: { which: 93, key: 'ContextMenu', code: 'ContextMenu' },
  COMMA: { which: 188, key: ',', code: 'Comma' },
};
export default KeyEventValues;
